<template>
  <div
    ref="anchor"
    :class="['lego-modal lego-scroll', customClass]"
    :style="anchorStyle"
    v-show="isOpen"
    @mouseup="mUp"
    @mousemove="mMove"
    @click="onClick"
    @keydown.backspace="keyBackspace"
    v-bind="$attrs"
  >
    <div class="lego-modal__blocker" ref="blocker" />
    <div ref="modal" class="lego-modal__container" :style="modalStyle" :class="modalClass">
      <div class="modal__header" :style="contentStyle('header')" @mousedown="mDown">
        <slot name="header">
          <div v-if="subTitle" class="modal__title-bar">
            <div class="modal__title">{{ title }}</div>
            <div class="modal__title-divider"></div>
            <div class="modal__title-bar__sub ellipsis" v-lego-tooltip:ellipsis="subTitle">
              {{ subTitle }}
            </div>
          </div>
          <span v-else class="modal__title">{{ title }}</span>
          <span class="modal__close_icon">
            <lego-icon @click.stop="close">close</lego-icon>
          </span>
        </slot>
      </div>
      <div class="modal__body" :style="contentStyle('body')">
        <slot />
      </div>
      <div class="modal__footer" :style="contentStyle('footer')">
        <slot name="footer" :close="close">
          <lego-button @click.stop="close">{{ $t('button.close') }}</lego-button>
        </slot>
      </div>
    </div>
  </div>
</template>
<script>
import legoEventBus from '@/lego-component/utils/eventBus/eventBus';
let ZIDX = 100;
const ZIDX_MAP = new Map();

function modalPush(key) {
  let zidx = ++ZIDX;
  ZIDX_MAP.set(key, zidx);
  return zidx;
}

function modalPop(key) {
  // 1. check map exist
  if (!ZIDX_MAP.has(key)) return -1; // 아무의미 없음. 안쓰임. code smell 회피
  // 2. get his/her zidx
  let zidx = ZIDX_MAP.get(key);
  // 3. delete from map
  ZIDX_MAP.delete(key);
  // 4. set ZIDX
  //    조심! 모달 열리는 순서 꼬이는경우
  //    조심! blocker 안하는 경우, 아무렇게나 모달을 열었을때
  //        -> 그때는 focus 기반으로 active 배열을 얹어야 할지도.. 문제는 속도지 뭐
  ZIDX = zidx - 1;
  return 0;
}
const DEFAULT_MODAL_STYLE = {
  padding: '24px 32px 24px 32px',
  width: 1600,
  height: 900,
  header: {
    padding: '0px 0px 15px 0px',
    fontSize: '22px',
    lineHeight: '32px',
    fontWeight: 'bold',
    borderBottom: '1px #E3E5E8 solid',
    width: '100%'
  },
  footer: { padding: '19px 0px 0px 0px', borderTop: '1px #E3E5E8 solid' }
};
export default {
  emits: ['opened', 'closed'],
  props: {
    height: {
      type: [String, Number],
      default: () => DEFAULT_MODAL_STYLE.height
    },
    width: {
      type: [String, Number],
      default: () => DEFAULT_MODAL_STYLE.width
    },
    padding: {
      type: [String, Number],
      default: () => DEFAULT_MODAL_STYLE.padding
    },
    customStyle: {
      type: Object,
      default: () => ({
        modal: null,
        header: null,
        body: null,
        footer: null
      })
    },
    subTitle: {
      type: String,
      default: ''
    },
    customClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    modalStyle() {
      let height = this.height;
      let width = this.width;
      let padding = this.padding;
      if (typeof this.height === 'number') height += 'px';
      if (typeof this.width === 'number') width += 'px';
      if (typeof this.padding === 'number') padding += 'px';
      return { width, height, padding, ...(this.customStyle.modal || {}) };
    }
  },
  mounted() {
    legoEventBus.$emit('open-modal', true);
  },
  beforeUnmount() {
    legoEventBus.$emit('open-modal', false);
  },
  methods: {
    contentStyle(element) {
      if (!this.customStyle[element]) return DEFAULT_MODAL_STYLE[element];
      return { ...DEFAULT_MODAL_STYLE[element], ...this.customStyle[element] };
    },
    open(e) {
      this.dimOn();
      document.activeElement.blur();
      // 1. set focus
      this.isOpen = true;
      this.$nextTick(() => {
        let anchor = this.$refs.blocker;
        anchor.setAttribute('tabindex', -1);
        anchor.focus();
      });
      // 2. set zidx
      this.zidx = modalPush(this.tempKey);

      //this.posx = window.innerWidth  / 2;
      //this.posy = window.innerHeight / 2;

      // $ver: v0.1.0
      // $return: event
      // 팝업이 열릴 때, 이벤트를 발생시킵니다.
      this.$emit('opened', e);

      this.$slots.default() && this.$slots.default().forEach((defaultSlot) => {
        if (!defaultSlot.componentInstance) {
          return;
        }
        let fn = defaultSlot.componentInstance.onLoadModal;
        if (fn && typeof fn === 'function') {
          fn();
        }
      });
      this.$slots.action &&
        this.$slots.action().forEach((actionSlot) => {
          if (!actionSlot.componentInstance) {
            return;
          }
          let fn = actionSlot.componentInstance.onLoadModal;
          if (fn && typeof fn === 'function') {
            fn();
          }
        });

      this.$nextTick(() => {
        this.moveModal(0, 0);
      });
    },
    close(e) {
      //console.log('legoModalExtend... close')
      this.dimOff();
      if (this.$attrs['onBeforeClose']) {
        // $ver: v0.1.2
        // $arg: function close()
        // beforeClose라는 event에 callback method가 설정되어있다면 modal을 닫기 전에
        // 해당 callback을 실행합니다. 첫번 째 인자로 modal을 닫는 function이 전달됩니다.
        // #If the callback method is set in the beforeClose event, the callback is executed before closing the modal.
        // #The first argument is passed a function that closes the modal.
        this.$attrs['onBeforeClose'](() => {
          this.isOpen = false;
          this.$emit('closed', e);
          this.zidx = modalPop(this.tempKey);
        });
      } else {
        this.isOpen = false;

        // $ver: v0.1.0
        // $arg: event
        // 팝업이 닫힐 때, 이벤트를 발생시킵니다.
        // #Raises an event when the popup closes.
        this.$emit('closed', e);
        this.zidx = modalPop(this.tempKey);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.modal {
  &__title {
    &-bar {
      display: flex;
      gap: 16px;
      align-items: center;
      width: calc(100% - 32px);

      &__sub {
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        flex: 1;
      }
    }
    &-divider {
      height: 12px;
      border-right: 1px solid #cfd2d8;
    }
  }
}
.lego-modal {
  display: flex;
  justify-content: center;
  align-items: center;
}
.lego-modal__container {
  display: flex;
  flex-direction: column;
  position: fixed;
}
.modal__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal__body {
  flex-grow: 1;
  max-height: 100%;
  overflow: auto;
}
.modal__footer {
  display: flex;
  justify-content: end;
  align-items: center;
}
.modal__close_icon {
  display: flex;
  justify-content: center;
  font-size: 20px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
.modal__close_icon:hover {
  background-color: #f4f4f6;
}
</style>
